"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var js_cookie_1 = __importDefault(require("js-cookie"));
var find_1 = __importDefault(require("lodash/find"));
var map_1 = __importDefault(require("lodash/map"));
var NAMESPACE = 'aula-auth';
var SSO_COOKIE = 'sso-session-t';
var AAStorage = /** @class */ (function () {
    function AAStorage() {
        this.emails = {};
        this.load();
    }
    AAStorage.prototype.load = function () {
        var cookie = js_cookie_1.default.getJSON(NAMESPACE);
        this.emails = cookie ? cookie.emails : {};
    };
    AAStorage.prototype.setEmailCookie = function () {
        var cookie = js_cookie_1.default.getJSON(NAMESPACE);
        js_cookie_1.default.set(NAMESPACE, __assign(__assign({}, cookie), { emails: this.emails }), {
            secure: true,
            expires: 9999,
            domain: window.location.hostname === 'localhost'
                ? 'localhost'
                : '.aula.education',
        });
    };
    AAStorage.prototype.set = function (session, domain, email) {
        var cookie = {
            session: session,
            domain: domain,
        };
        if (this.emails[email] instanceof Array) {
            var existsAlready = this.emails[email].find(function (e) { return e.domain === domain; });
            var newDomains = [];
            if (existsAlready) {
                newDomains = this.emails[email].map(function (acct) {
                    return acct.domain === domain ? cookie : acct;
                });
                this.emails[email] = newDomains;
            }
            else {
                this.emails[email].push(cookie);
            }
        }
        else {
            this.emails[email] = [cookie];
        }
        this.setActiveDomain(domain, email);
    };
    AAStorage.prototype.getSession = function (domain, email) {
        return (0, find_1.default)(this.emails[email], { domain: domain });
    };
    AAStorage.prototype.getDomains = function (email) {
        return (0, map_1.default)(this.emails[email], 'domain');
    };
    AAStorage.prototype.getLoggedInUsers = function () {
        return this.emails;
    };
    AAStorage.prototype.setActiveDomain = function (domain, email) {
        var _this = this;
        Object.keys(this.emails).forEach(function (em) {
            var accounts = (0, map_1.default)(_this.emails[em], function (a) {
                if (a.domain === domain) {
                    if (email === em) {
                        a.active = true;
                        return a;
                    }
                    delete a.active;
                    return a;
                }
                return a;
            });
            _this.emails[em] = accounts;
        });
        this.setEmailCookie();
    };
    AAStorage.prototype.getActiveUserInDomain = function (domain) {
        var _this = this;
        var user = null;
        Object.keys(this.emails).forEach(function (email) {
            var account = (0, find_1.default)(_this.emails[email], { domain: domain, active: true });
            if (account) {
                user = email;
            }
        });
        return user;
    };
    AAStorage.prototype.setLoggedOut = function (domain, email) {
        var _this = this;
        var setLoggedOutCookie = function (accts) {
            return accts.filter(function (acct) { return acct.domain !== domain; });
        };
        if (this.emails[email]) {
            this.emails[email] = setLoggedOutCookie(this.emails[email]);
        }
        else {
            // iterate over each email and log out all matching domains
            Object.keys(this.emails).map(function (e) {
                _this.emails[e] = setLoggedOutCookie(_this.emails[e]);
            });
        }
        this.setEmailCookie();
    };
    AAStorage.prototype.getSSOCookie = function () {
        return js_cookie_1.default.get(SSO_COOKIE);
    };
    AAStorage.prototype.deleteSSOCookie = function () {
        return js_cookie_1.default.remove(SSO_COOKIE);
    };
    return AAStorage;
}());
exports.default = AAStorage;
